// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import {session} from 'wix-storage';
import wixLocation from 'wix-location';
import {SessionStart} from 'public/Hevrati.js';
import {NewLead} from 'public/Hevrati.js';
import {Track} from 'public/Hevrati.js';

$w.onReady(function () {

    SessionStart();

	$w("#text13").onViewportEnter( () => {
        $w("#button13").show("fade");
    });
 
    $w("#videoPlayer1").onPlay( (event) => {
        Track("Video", "Play");
    });

    $w("#videoPlayer1").onPause( (event) => {
        session.setItem("videoPlayed", $w("#videoPlayer1").currentTime);
    });

    $w("#dataset1").onAfterSave( () => {
        session.setItem("videoPlayed", $w("#videoPlayer1").currentTime);  
        NewLead($w("#input1").value, $w("#input2").value, '/talk');
    } );

});